export default __webpack_public_path__ + "static/report-mobile-banner-094f097dc18b3d6ef5ff882e4ba926a1.png";